export const rarities = [
    {
        title: "Первобытный предмет",
        color: "#b3b3b3",
        percentMax: 100,
        percentMin: 40,
    },
    {
        title: "Небрежный предмет",
        color: "#33FF33",
        percentMax: 39,
        percentMin: 20,
    },
    {
        title: "Работа новичка",
        color: "#334CFF",
        percentMax: 19,
        percentMin: 16,
    },
    {
        title: "Работа подмастерья",
        color: "#7F33FF",
        percentMax: 15,
        percentMin: 12,
    },
    {
        title: "Работа мастера",
        color: "#FFF319",
        percentMax: 11,
        percentMin: 7,
    },
    {
        title: "Легендарный предмет",
        color: "#00FFFF",
        percentMax: 6,
        percentMin: 0,
    },
]